import Vue from 'vue'
import store from '@/store/index'
import {DateTime} from 'luxon'
import {capitalizer} from '../capitalizer'

export function openTabsSidebar (name: string, props: any) {
  store.dispatch('tabsSidebar/sidebarOpen', {
    name: name,
    props: props
  })
}

export function closeTabsSidebar (name?: string) {
  if (name) {
    store.dispatch('tabsSidebar/sidebarClose', name)
  } else {
    store.dispatch('tabsSidebar/sidebarClose')
  }
}

export default {
  install () {
    Vue.prototype.$openTabsSidebar = openTabsSidebar
    Vue.prototype.$closeTabsSidebar = closeTabsSidebar
  }
}

declare module 'vue/types/vue' {
  interface Vue {
    $openTabsSidebar: (name: string, props: any) => void;
    $closeTabsSidebar: (name?: string) => void;
  }
}